// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-l_gP","advertDetailContactItem__link":"c-l_gQ","advertDetailContactItem__stub":"c-l_gR"};